import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import CarrierMultiSelect from '../Tabs/Mnr/CarrierMultiSelect';
import { fetchReportsCarriers, setSelectedCarriers } from '../Redux/Reports/ReportsCarrierSlice';
import { triggerDatabricksJobWithCarrierData } from '../Redux/DataBricks/MMTDataBricksSlice';
import { toast } from 'react-toastify';

const ReportsCarrier = ({ tabIndex = 0 }) => {
  const dispatch = useDispatch();
  const carrierList = useSelector(state => state.reportsCarrier.carrierList);
  const loading = useSelector(state => state.reportsCarrier.loading);
  const error = useSelector(state => state.reportsCarrier.error);
  const selectedCarriers = useSelector(state => state.reportsCarrier.selectedCarriers);

  useEffect(() => {
    if (!loading && carrierList.length === 0 && !error) {
      dispatch(fetchReportsCarriers());
    }
  }, [dispatch, loading, carrierList.length, error]);

  const handleSelectionChange = (newValue) => {
    dispatch(setSelectedCarriers(newValue));
  };

  const handleRun = async () => {
    try {
      const carriersForPayload = selectedCarriers.map(c => c.carrier || c).filter(Boolean);
      const action = await dispatch(triggerDatabricksJobWithCarrierData({ tabIndex, selectedCarriers: carriersForPayload }));
      if (triggerDatabricksJobWithCarrierData.fulfilled.match(action)) {
        const runId = action.payload.runId ?? 'N/A';
        toast.success(`Databricks job started (Run ID: ${runId})`);
      }
      else if (triggerDatabricksJobWithCarrierData.rejected.match(action)) {
        toast.error(action.payload || 'Failed to start Databricks job');
      }
    } catch (error) {
      toast.error('Failed to trigger Databricks job');
      console.error('Error triggering Databricks job:', error);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Box sx={{ flex: '1 1 600px', maxWidth: 600 }}>
          <CarrierMultiSelect
            // Controlled props
            carriers={carrierList}
            loading={loading}
            error={error}
            selected={selectedCarriers}
            onSelectionChange={handleSelectionChange}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Button
            variant="contained"
            color="primary"
            //disabled={selectedCarriers.length === 0 || loading}
            onClick={handleRun}
            sx={{ minWidth: 160, marginTop: '2px' }}
          >
            Start New Run
          </Button>
        </Box>
      </Box>
      <div style={{ marginTop: '16px' }}><i>Note: Clicking 'Start New Run' will automatically select all carriers in DataBricks.</i></div>
    </>
  );
};

export default ReportsCarrier;